const $$splitComponentImporter = () => import('/data/circle/current/app/javascript/react/tanstack_routes/_protected/account/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { punditUserQueries } from "@circle-react/lib/queries/punditUser";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_protected/account")({
  // context.punditUserContext can be a stale localStorage copy (e.g. the logged-out
  // one right after login), so /account decides on a fresh fetch instead.
  beforeLoad: async ({
    context
  }) => ({
    punditUser: await context.queryClient.fetchQuery({
      ...punditUserQueries.show(),
      staleTime: 0
    })
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});